import { render } from "./horizondalbarsurvival.vue?vue&type=template&id=f57ebba6"
import script from "./horizondalbarsurvival.vue?vue&type=script&lang=js"
export * from "./horizondalbarsurvival.vue?vue&type=script&lang=js"

import "./horizondalbarsurvival.vue?vue&type=style&index=0&id=f57ebba6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__